// @flow
import { addEvent, removeEvent, each } from './utils';

import MicroEvent from './microevent';

import type { Player$Logger } from './types/Logger';

export default class Entity {
   _tokens: Array<mixed> = []
   bus: MicroEvent
   logger: Player$Logger

   constructor(bus: MicroEvent, logger: Player$Logger) {
      this.bus = bus;
      this.logger = logger;
   }

   addEvent(el: EventTarget, event: string, callback: (Event) => void, useCapture: boolean = false) {
      const token = addEvent(el, event, callback, useCapture);
      this._tokens.push(token);
   }

   destroy() {
      each(this._tokens, removeEvent);
      this._tokens.length = 0;
   }
}
